import React from "react"

const CommentBox = ({ comment, setComment, placeholder, required, error, disabled }) => {
  const setCommentHandler = e => {
    setComment(e.target.value)
  }

  return (
    <div className="row mt-3 form-group border-0 comment-input">
      <div className="col-sm-12">
        <input
          type="text"
          className={`form-control ${error ? "is-invalid" : ""}`}
          placeholder={placeholder || (required ? "Add Comment (Required)" : "Add Comment")}
          value={comment}
          onChange={setCommentHandler}
          required={required}
          disabled={disabled} />
        {error && (
          <div className="invalid-feedback d-block">{error}</div>
        )}
        {required && !error && (
          <small className="form-text text-muted">Comment is required for this boundary issue type</small>
        )}
      </div>
    </div>
  )
}

export default CommentBox
